import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Notification, NotificationState } from 'models/Notification';

export const initialState: NotificationState = {
  notifications: [],
};

export const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    createNotification: (state, action) => {
      state.notifications.push({
        type: action.payload.type,
        status: action.payload.status,
        message: action.payload.message,
        canClose: action.payload.canClose !== false,
      });
    },
    deleteNotification: (state, action: PayloadAction<Notification | number>) => {
      const payload = action.payload;
      if (typeof payload === 'number') state.notifications.splice(payload, 1);
      else {
        state.notifications = state.notifications.filter((notification) => notification.message !== payload.message);
      }
    },
    clearNotification: (state) => {
      state.notifications.length = 0;
    },
  },
});

export const { createNotification, deleteNotification, clearNotification } = notificationSlice.actions;
